import type { OnlineShareChannel } from 'src/app/pages/starterDashboardV2/shared/types';
import type { ReadyToSharePosts } from 'src/app/shared/api/readyToShare';
import type { ShareAction, ShareChannel } from 'src/app/shared/hooks/share';
import { useAvailableShareActions } from 'src/app/shared/hooks/share';

import { useDashboardShareChannels } from './useDashboardShareChannels';
import { useDashboardShareOptions } from './useDashboardShareOptions';

type OnlineShareAction = ShareAction & { channel: OnlineShareChannel };
export function useDashboardShareActions(
	channel?: OnlineShareChannel,
	previewLinkConfigs?: ReadyToSharePosts['items'],
	customTrackingData?: Array<Record<string, string>>,
	customUtmParams?: Array<Record<string, string>>,
): readonly OnlineShareAction[] {
	const options = useDashboardShareOptions(previewLinkConfigs, customTrackingData, customUtmParams);
	const channels = useDashboardShareChannels();
	return useAvailableShareActions(channel ? [channel] : channels, options);
}

export type DashboardShareAction = ShareAction<ShareChannel>;
